module.exports = __webpack_public_path__ + "static/MOE-6e717a5b08b36e9bca32ee006c6256b9.png";